const initialState = {
  getNotificationChild: [],
  getNotificationLady: [],
  getNotificationPop: [],
  getDataCount: {},
  getState: 0,
  datacount: 0,
  getStateLady: 0,
  getStatePop: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_NOTIFICATIONS_CHILD_FULFILLED":
      return {
        ...state,
        getState: 2,
        getNotificationChild: action.payload.data,
      };
    case "GET_NOTIFICATIONS_CHILD_REJECTED":
      return { ...state, getState: 3 };
    case "GET_NOTIFICATIONS_CHILD_PENDING":
      return { ...state, getState: 1 };
    case "GET_NOTIFICATIONS_LADY_FULFILLED":
      return {
        ...state,
        getStateLady: 2,
        getNotificationLady: action.payload.data,
      };
    case "GET_NOTIFICATIONS_LADY_REJECTED":
      return { ...state, getStateLady: 3 };
    case "GET_NOTIFICATIONS_LADY_PENDING":
      return { ...state, getStateLady: 1 };
    case "GET_NOTIFICATIONS_LADY_POP_FULFILLED":
      return {
        ...state,
        getStatePop: 2,
        getNotificationPop: action.payload.data,
      };
    case "GET_NOTIFICATIONS_LADY_POP_REJECTED":
      return { ...state, getStatePop: 3 };
    case "GET_NOTIFICATIONS_LADY_POP_PENDING":
      return { ...state, getStatePop: 1 };
    case "GET_DATA_COUNT_FULFILLED":
      return {
        ...state,
        datacount: 2,
        getDataCount: action.payload.data,
      };
    case "GET_DATA_COUNT_REJECTED":
      return { ...state, datacount: 3 };
    case "GET_DATA_COUNT_PENDING":
      return { ...state, datacount: 1 };

    default:
      return state;
  }
};

export default reducer;
